// extracted by mini-css-extract-plugin
export default {"overlay":"myPage_overlay__aVkov","container":"myPage_container__gVYz-","line":"myPage_line__DVzD+","noContents":"myPage_noContents__0sPf9"};